/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const ChartJsonApiModel = {
  id: "",
  name: "",
  tags: "",
  metadata: "",
  "created-at": "",
  "updated-at": "",
};
